(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen2/assets/javascripts/app-init.js') >= 0) return;  svs.modules.push('/modules/matchen2/assets/javascripts/app-init.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const _ReactDOM = ReactDOM,
  render = _ReactDOM.render;
const _ReactRouterDOM = ReactRouterDOM,
  BrowserRouter = _ReactRouterDOM.BrowserRouter,
  MemoryRouter = _ReactRouterDOM.MemoryRouter;
const _ReactRedux = ReactRedux,
  Provider = _ReactRedux.Provider;
const baseUrl = svs.core.data.baseUrl;
const EngineProvider = svs.components.tipsen.engine.EngineProvider;
const AppContainer = svs.matchen2.AppContainer;
const makeStore = svs.components.tipsen.store.makeStore;
const ModalPortal = svs.components.lbUi.modal.ModalPortal;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const App = _ref => {
  let store = _ref.store,
    routerProps = _ref.routerProps;
  const Router = routerProps ? MemoryRouter : BrowserRouter;
  return React.createElement(React.StrictMode, null, React.createElement(ErrorBoundary, null, React.createElement(Router, _extends({
    basename: baseUrl
  }, routerProps), React.createElement(Provider, {
    store: store
  }, React.createElement(EngineProvider, null, React.createElement(ModalPortal, null, React.createElement(AppContainer, null)))))));
};
const init = appRoot => {
  if (appRoot) {
    const preloadedState = svs.tipsen.data.preloadedState;
    const store = makeStore({
      preloadedState,
      lsKey: 'svs.tipsen'
    });
    svs.components.tipsen.competition.competitionFactoryInstance.getCompetitionFactoryInstance(store);
    render(React.createElement(App, {
      store: store
    }), appRoot);
  }
};
const appRoot = document.getElementById('tipsen');
init(appRoot);

 })(window);